import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {HttpMachineOverviewService} from '@infrastructure/http/machine-overview/http-machine-overview.service';
import {MACHINE_OVERVIEW} from '@infrastructure/http/machine-overview/machine-overview';
import {CustomSettingsDialogHeaderComponent} from '@presentation/components/custom-settings-dialog/custom-settings-dialog-header.component';
import {MatchingCriteriaModule} from '@presentation/pages/utilities/tool/add/matching-criteria/matching-criteria.module';
import {SharedModule} from '@shared/shared.module';
import {CrudOverviewDataModule, EditorHeaderModule, SplitButtonModule} from '@vdw/angular-component-library';
import {PatternOverviewService} from '../pattern/overview/pattern-overview.service';
import {PatternSelectionService} from '../pattern/pattern-selection.service';
import {AddSchedulePageComponent} from './add/add-schedule-page.component';
import {ScheduleComponent} from './add/schedule/schedule.component';
import {ScheduleOverviewPageComponent} from './overview/schedule-overview-page.component';
import {ScheduleOverviewService} from './overview/schedule-overview.service';
import {scheduleRouting} from './schedule.routing';
import {ScheduleCustomSettingsComponent} from './settings/schedule-custom-settings.component';

@NgModule({
  imports: [scheduleRouting, CommonModule, SharedModule, CrudOverviewDataModule, EditorHeaderModule, CustomSettingsDialogHeaderComponent, SplitButtonModule, MatchingCriteriaModule],
  declarations: [ScheduleOverviewPageComponent, AddSchedulePageComponent, ScheduleCustomSettingsComponent, ScheduleComponent],
  providers: [{provide: MACHINE_OVERVIEW, useClass: HttpMachineOverviewService}, ScheduleOverviewService, PatternOverviewService, PatternSelectionService]
})
export class ScheduleModule {}
